import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWorkforceRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workforce',
	path: '/jira/servicedesk/projects/:projectKey/settings/workforce',
	exact: true,
};
